import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import { routes } from "./routes/index";
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './services/store'
import SlotTopo from './shared/SlotTopo.vue'
Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.component('TopoSlot',SlotTopo)
import VModal from 'vue-js-modal'

Vue.use(VModal)

Vue.config.productionTip = false
const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
